import React from 'react';
import PurchasedSubscribeManagement from "../subscribe/PurchasedSubscribeManagement";

const SellManagementSubscribeTab = () => {
    return (
        <>
            <PurchasedSubscribeManagement />
        </>
    );
};

export default SellManagementSubscribeTab;
